import React, { useEffect, useState } from "react";
import { Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField , SelectField, Option,} from "@deere/fuel-react";
import { DEFAULT_LANGUAGE_CODE } from "../../../../utils/surveyLiterals";
import { sortByLanguageList } from "../../../../utils/utils";

const SelectionsTranslationsTab = ({ payloadData, setPayloadData, selectedSec, que, payloadLanguages, languageList }) => {
  const payloadTranslationLanguages = payloadLanguages?payloadLanguages.filter((hd) => hd.languageCd !== DEFAULT_LANGUAGE_CODE) : [];
  const [selectedSelection, setSelectedSelection] = useState(null);
  useEffect(() => {
    if (payloadData.language && selectedSelection) {
      setPayloadData((prevState) => {
        const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
        const newSections = [...prevState.sections];
        const newQuestions = [...newSections[sectionIndex].questions];
        const questionIndex = newQuestions.findIndex((nq) => nq.code === que.code);
        const newSelections = [...newQuestions[questionIndex].selections];
        const selectionIndex = newSelections.findIndex((ns) => ns.code === selectedSelection);
        const newSelTranslations = [...newSelections[selectionIndex].translations];
        payloadTranslationLanguages.forEach((pl) => {
          const index = newSelTranslations.findIndex((nst) => nst.locale === pl.languageCd);
          if(index > -1)  newSelTranslations[index].language = pl.text;
          else  newSelTranslations.push({ locale: pl.languageCd, language: pl.text, text: "" });
        });
        newSelections[selectionIndex] = {...newSelections[selectionIndex], translations: newSelTranslations}
        newQuestions[questionIndex] = { ...newQuestions[questionIndex], selections: newSelections };
        newSections[sectionIndex] = { ...newSections[sectionIndex], questions: newQuestions };
        return { ...prevState, sections: newSections };
      });
    }
  }, [payloadData.language, selectedSelection]);

  const changeHandler = (e, sel, langCode) => {
    setPayloadData((prevState) => {
      const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
      const newSections = [...prevState.sections];
      const newQuestions = [...newSections[sectionIndex].questions];
      const questionIndex = newQuestions.findIndex((nq) => nq.code === que.code);
      const newSelections = [...newQuestions[questionIndex].selections];
      const selectionIndex = newSelections.findIndex((ns) => ns.code === sel.code);
      const newTranslations = [...newSelections[selectionIndex].translations];
      const translationIndex = newTranslations.findIndex((trn) => trn.locale === langCode);
      newTranslations[translationIndex].text = e.target.value;
      newSelections[selectionIndex] = {...newSelections[selectionIndex],translations: newTranslations};
      newQuestions[questionIndex] = { ...newQuestions[questionIndex], selections: newSelections};
      newSections[sectionIndex] = { ...newSections[sectionIndex], questions: newQuestions };
      return { ...prevState, sections: newSections };
    });
  };

  return (
    <Grid container mt={4} spacing={4}>
      <SelectField
          label="Select your options"
          sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}
          onChange={(e) => {
            setSelectedSelection(e.target.value)
          }}
          value={selectedSelection}
      >
        <Option disabled hidden>
          Select
        </Option>
        {que.selections.sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1)).map((sel) => (
          <Option key={sel.code} value={sel.code}>
            {sel.text}
          </Option>
        ))}
      </SelectField>
      <Table size="small">
        <TableHead sx={{ border: "none" }}>
          <TableRow>
            <TableCell>Translations</TableCell>
            <TableCell>Language</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
           {que.selections
           .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
           .filter((sel)=>sel.code===selectedSelection)
          .map((sel) => (
              <>
              {
                sortByLanguageList(sel?.translations, languageList).map((tr)=>(
                  <TableRow key={tr.locale} sx={{ border: "none!important" }}>
                    <TableCell>
                      <TextField required placeholder="Please provide the translation here..." onChange={(e) => changeHandler(e, sel, tr.locale)} value={tr.text} />
                    </TableCell>
                    <TableCell>{tr.language}</TableCell>
                  </TableRow>
                ))
            }
              </>
          ))} 
        
      </TableBody>
      </Table>
    </Grid>
  );
};

export default SelectionsTranslationsTab;
